<template>
	<div class="range-container">
		<div class="range-marks-container">
			<template v-for="index in elementsRange" :key="index">
				<div class="range-mark">{{ index }}</div>
				<div class="range-flex-pad"></div>
			</template>
			<div class="range-mark">{{ endValue }}</div>
		</div>
		<div class="range-buttons-container">
			<div v-for="state in elementsStates" :key="state.index" :class="['range-button', state.activeClass]" @click="onClick(state.index)"></div>
		</div>
	</div>
</template>

<script>
import { arrayRange } from './utils';

export default {
	components: {
	},
	emits: ['update:modelValue'],
	props: {
		startValue: {
			type: Number,
			default: 0,
		},
		endValue: {
			type: Number,
			default: 24,
		},
		modelValue: {
			type: Array,
			default(rawProps) {
				return [];
			}
		},
	},
	computed: {
		elementsRange() {
			return arrayRange(this.startValue, this.endValue);
		},
		elementsStates() {
			let result = [];
			for (let index = this.startValue; index < this.endValue; index++) {
				result.push({
					index: index,
					activeClass: this.modelValue.includes(index) ? 'range-button-is-active': '',
				});
			}
			return result;
		}
	},
	methods: {
		onClick(index) {
			let result = [...this.modelValue];
			if (result.includes(index)) {
				result = result.filter(e => e !== index)
			} else {
				result.push(index);
			}
			this.$emit('update:modelValue', result);
		}
	},
}
</script>

<style scoped>
.range-container {
	margin: var(--van-padding-md);
}

.range-marks-container {
	display: flex;
}
.range-mark {
	width: 11px;
	font-size: 11px;
	text-align: center;
}
.range-flex-pad {
	flex-grow: 1;
}

.range-buttons-container {
	display: flex;
	padding: 0 5px;
}
.range-button {
	flex-grow: 1;
	cursor: pointer;
	margin: 0 1px 0 0;
	height: 23px;
	border-radius: 3px;
	background-color: var(--van-switch-background);
}
.range-button-is-active {
	background-color: #13A10E;
}
</style>
